import React, { type FC } from "react";
import { withPrefix } from "@tracking/tracking";
import { useTrackElement, useTranslation } from "@edreamsodigeo/frontend-core";
import { Box, Glyph } from "@edreamsodigeo/prisma-design-system";

import { type GoBackHeaderProps } from "./contract";

const GoBackHeaderContent: FC<GoBackHeaderProps> = ({
  screen,
  trackingPrefix,
}) => {
  const { t } = useTranslation();
  const trackingRef = useTrackElement(
    ["click"],
    withPrefix(`${screen}_back`, trackingPrefix),
  );

  return (
    <Box ml="minus_base">
      <Box
        ref={trackingRef}
        aria-label={t("authentication.header.back")}
        role="button"
      >
        <Glyph category="Arrows" name="Left" size="medium" color="neutral.80" />
      </Box>
    </Box>
  );
};

export default GoBackHeaderContent;
